import {
  GET_HARDWARE_PRODUCTS,
  UPDATE_HARDWARE_PRODUCTS,
  GET_HARDWARE_BASE_PRODUCTS,
  UPDATE_HARDWARE_BASE_PRODUCTS,
  SET_HARDWARE_LOADING,
  SHOW_CREATE_HARDWARE_MODAL,
  SHOW_EDIT_HARDWARE_MODAL,
  SET_HARDWARE_EDITOR_LOADING,
  SET_HARDWARE_EDITOR_ERROR,
  SAVE_HARDWARE_PRODUCT,
  SHOW_DELETE_HARDWARE_CONFIRMATION,
  SET_HARDWARE_DELETE_LOADING,
  DELETE_HARDWARE_PRODUCT,
  HARDWARE_CATALOGUE_DO_SHOW_LOG,
  HARDWARE_CATALOGUE_LOG_SET_SHOWN,
  HARDWARE_CATALOGUE_LOG_CHANGE_PAGE,
  HARDWARE_CATALOGUE_LOG_SET_DATA,
  HARDWARE_CATALOGUE_LOG_SET_IS_LOADING,
  HARDWARE_CATALOGUE_LOG_SET_ERRORS,
} from './actionTypes';

export const getHardwareProducts = () => ({
  type: GET_HARDWARE_PRODUCTS,
});

export const updateHardwareProducts = products => ({
  type: UPDATE_HARDWARE_PRODUCTS,
  payload: products,
});

export const getHardwareBaseProducts = () => ({
  type: GET_HARDWARE_BASE_PRODUCTS,
});

export const updateHardwareBaseProducts = baseProducts => ({
  type: UPDATE_HARDWARE_BASE_PRODUCTS,
  payload: baseProducts,
});

export const setHardwareLoading = isLoading => ({
  type: SET_HARDWARE_LOADING,
  payload: isLoading,
});

export const showCreateHardwareModal = shown => ({
  type: SHOW_CREATE_HARDWARE_MODAL,
  payload: { shown },
});

export const showEditHardwareModal = (shown, productData) => ({
  type: SHOW_EDIT_HARDWARE_MODAL,
  payload: { shown, productData },
});

export const setHardwareEditorLoading = isLoading => ({
  type: SET_HARDWARE_EDITOR_LOADING,
  payload: isLoading,
});

export const setHardwareEditorError = (errorMessage, errors = []) => ({
  type: SET_HARDWARE_EDITOR_ERROR,
  payload: { message: errorMessage, errors },
});

export const saveHardwareProduct = (productPayload, isEditMode) => ({
  type: SAVE_HARDWARE_PRODUCT,
  payload: {
    productPayload,
    isEditMode,
  },
});

export const showDeleteHardwareConfirmation = (shown, productData) => ({
  type: SHOW_DELETE_HARDWARE_CONFIRMATION,
  payload: { shown, productData },
});

export const setHardwareDeleteLoading = isLoading => ({
  type: SET_HARDWARE_DELETE_LOADING,
  payload: isLoading,
});

export const deleteHardwareProduct = productId => ({
  type: DELETE_HARDWARE_PRODUCT,
  payload: { productId },
});

export const doShowLogs = () => ({
  type: HARDWARE_CATALOGUE_DO_SHOW_LOG,
});

export const setLogModalShown = shown => ({
  type: HARDWARE_CATALOGUE_LOG_SET_SHOWN,
  payload: { shown },
});

export const setLogPage = page => ({
  type: HARDWARE_CATALOGUE_LOG_CHANGE_PAGE,
  payload: { page },
});

export const setLogData = (data, paging) => ({
  type: HARDWARE_CATALOGUE_LOG_SET_DATA,
  payload: { data, paging },
});

export const resetLogData = () =>
  setLogData([], { page: 1, size: 20, total: 0 });

export const setLogIsLoading = isLoading => ({
  type: HARDWARE_CATALOGUE_LOG_SET_IS_LOADING,
  payload: { isLoading },
});

export const setLogErrors = errors => ({
  type: HARDWARE_CATALOGUE_LOG_SET_ERRORS,
  payload: { errors },
});

export const clearLogErrors = () => setLogErrors([]);
